module.exports = __webpack_public_path__ + "assets/img/p-center@2x.9bc27841.png";